/**
 * Icon neben „Leads in der Kampagne": Kommen aus der Suche noch Kontakte nach,
 * oder ist die Kampagne wirklich leer? Die Entscheidung trifft das Backend
 * (`stats.contactSupply`); hier wird sie nur in Icon und Hovertext übersetzt.
 */

import type { FunnelSummary } from './campaign-overview.types';

export type ContactSupplyIndicator =
  | { kind: 'more'; remaining: number }
  | { kind: 'exhausted'; unsent: number };

const toCount = (value: unknown): number => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

export function getContactSupplyIndicator(summary?: Partial<FunnelSummary> | null): ContactSupplyIndicator | null {
  switch (summary?.contactSupply) {
    case 'more':
      return { kind: 'more', remaining: toCount(summary.searchContactsRemaining) };
    case 'exhausted':
      return { kind: 'exhausted', unsent: toCount(summary.unsentContactsCount) };
    default:
      // 'none' oder unbekannt: Kampagne ohne Suchen (Listen-Upload) — kein Icon.
      return null;
  }
}

export function getContactSupplyTooltip(indicator: ContactSupplyIndicator): { key: string; count: number } {
  if (indicator.kind === 'more') {
    return indicator.remaining > 0
      ? { key: 'leadSupplyMore', count: indicator.remaining }
      : { key: 'leadSupplyMoreUnknown', count: 0 };
  }
  return indicator.unsent > 0
    ? { key: 'leadSupplyExhaustedWithReserve', count: indicator.unsent }
    : { key: 'leadSupplyExhausted', count: 0 };
}
